import { createClient as createSupabaseClient } from "@supabase/supabase-js";
import { env } from "@config/env";
import { getSupabaseAuthStorage } from "@lib/supabase/auth-storage";

let client: ReturnType<typeof createSupabaseClient> | undefined;

/**
 * Browser Supabase singleton.
 * Session persists in localStorage on web; Capacitor Preferences on native.
 */
export function createClient() {
  if (!client) {
    client = createSupabaseClient(env.supabaseUrl(), env.supabasePublishableKey(), {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // OAuth is exchanged manually on `/auth/callback` so we never double-exchange
        // (detectSessionInUrl + manual exchange races and strips `code` from the URL).
        detectSessionInUrl: false,
        flowType: "pkce",
        storage: getSupabaseAuthStorage(),
      },
    });
  }
  return client;
}

export type SupabaseClient = ReturnType<typeof createClient>;
